
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_57809_5956)","stroke":"#282E3E","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 12.5V10h1.5L6 8.5V14l-1.5-1.5H3zM8 9.5A2.031 2.031 0 018 13M9.5 2v3.5H13"}}),_c('path',{attrs:{"d":"M10.5 14h2a.5.5 0 00.5-.5v-8L9.5 2h-6a.5.5 0 00-.5.5v5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_57809_5956"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    